import NewsletterTable from "./components/newsletter-table";

export default function NewsletterPage() {
  return <NewsletterTable />;
}
